import React from 'react';
import withCanvasContainer, { WithCanvasContainerProps } from './withCanvasContainer';
import WellVirtualPlateWithIngredients from './wellVirtualPlateWithIngredients';
import { DisplayMode } from 'components/Experiment/constants';

type Props = WithCanvasContainerProps;

const IngredientCanvas = (props: Props) => {
  return (
    <>
      <WellVirtualPlateWithIngredients
        {...props}
        displayMode={DisplayMode.WELLINGREDIENT}
      />
    </>
  );
};

export default withCanvasContainer(IngredientCanvas, 'ingredientCanvas');
